import { useEffect, useState } from "react";
import { WorkspaceModal } from "@gull";
import { Button, Badge } from "react-bootstrap";
import { MdCampaign, MdDone } from "react-icons/md";
import { comunicazioniLette, segnaComunicazioniLette } from "app/services/comunicazioniLettura";
import useComunicazioniImportanti from "./useComunicazioniImportanti";

export default function ComunicazioniImportanti({ comunicazioni } = {}) {
  const caricate = useComunicazioniImportanti(comunicazioni === undefined);
  const [lette, setLette] = useState(comunicazioniLette);
  const messaggi = (comunicazioni ?? caricate).filter(m => !lette.has(String(m.idComunicazione)));

  useEffect(() => {
    const sincronizzaLetture = () => {
      setLette(comunicazioniLette());
    };
    window.addEventListener("storage", sincronizzaLetture);
    return () => {
      window.removeEventListener("storage", sincronizzaLetture);
    };
  }, []);

  // Rilegge lo storage anche quando arriva una risposta API iniziata in un'altra pagina.
  useEffect(() => { setLette(comunicazioniLette()); }, [comunicazioni, caricate]);

  const chiudi = () => {
    segnaComunicazioniLette(messaggi);
    setLette(comunicazioniLette());
  };

  return <WorkspaceModal show={messaggi.length > 0} size="lg" compact
    title={<><h2><MdCampaign aria-hidden="true" />Comunicazioni importanti</h2>
      <p className="gull-modal-subtitle"><span>Leggi gli aggiornamenti prima di proseguire.</span></p></>}
    onClose={chiudi} footer={<><span className="small text-muted me-auto">{messaggi.length} {messaggi.length === 1 ? "comunicazione da leggere" : "comunicazioni da leggere"}</span>
      <Button onClick={chiudi}><MdDone aria-hidden="true" />Ho letto</Button></>}>
    {messaggi.map((m, index) => <article key={m.idComunicazione} className="border rounded p-3 mb-3">
      <div className="d-flex justify-content-between align-items-center gap-2 mb-2"><Badge bg="warning" text="dark">Importante</Badge><span className="small text-muted">{index + 1} di {messaggi.length}</span></div>
      <h3 className="h5 text-primary text-break">{m.titolo}</h3>
      <div className="overflow-auto text-break" dangerouslySetInnerHTML={{ __html: m.messaggio }} />
    </article>)}
  </WorkspaceModal>;
}
